/* track.ts — 서비스 이용 이벤트 발화 (개인정보처리방침 §1-⑧)
 *
 * 화면에서 계측을 부를 때 지켜야 할 것이 매번 같아서 한곳에 모은다:
 *
 *   ① **동적 import** — supabase 클라이언트를 첫 페인트 경로 밖으로 민다.
 *   ② **await 하지 않는다** — 계측을 기다리다 화면이 멈추면 안 된다.
 *      부트 경로에서 supabase를 기다렸다가 auth 좀비 락으로 앱이 고착된 사고가 있었다(2026-07-26).
 *   ③ **실패를 삼킨다** — 계측 실패가 본 기능을 막으면 안 된다(lib/userEvents.js와 같은 규율).
 *
 * ⚠ 여기서 부를 수 있는 이벤트는 **방침 §1-⑧에 열거된 것만**이다.
 *   테이블 CHECK가 최종 방어지만, 문서에 없는 이벤트를 넣으면 그 순간 방침 위반이 된다.
 *   새 이벤트를 추가할 때는 반드시 app/privacy/page.js §1-⑧ 열거를 함께 고칠 것.
 */

/** 매번 기록되는 이벤트. */
export function trackEvent(event: string, props: Record<string, unknown> = {}): void {
  void import("./supabase")
    .then(({ supabase }) => supabase.rpc("log_event", { p_event: event, p_props: props }))
    .then(() => undefined, () => undefined);
}

/**
 * 하루 1건만 기록되는 이벤트(현재 `app_open`).
 * 중복 판정은 **서버가 한다** — localStorage로 하면 기기마다 다르고 지우면 중복이 들어온다.
 */
export function trackDailyEvent(event: string, props: Record<string, unknown> = {}): void {
  void import("./supabase")
    .then(({ supabase }) => supabase.rpc("log_daily_event", { p_event: event, p_props: props }))
    .then(() => undefined, () => undefined);
}
